import { atom } from 'jotai'
import { atomWithListeners, LifecycleState, PersistenceState } from '../../utilities'

export type ExportConfig = {
	exportTargetId: string | null
	syncDisqualifiedCandidates: boolean
	availableExportTargetSearch: string
}

export type ExportStatus = {
	komboStatus: 'enabled' | 'disabled'
	komboToolId: string
	komboIntegrationType: string
}

export type AvailableExportTarget = {
	id: string
	name: string | null
	status: string | null
	location: string | null
	employmentType: string | null
	postUrl: string | null
}

export const [exportConfigAtom, useExportConfigListener] = atomWithListeners<ExportConfig | undefined>(
	undefined,
)

export const exportConfigStatusAtom = atom<LifecycleState>('idle')
export const exportConfigSavingAtom = atom<PersistenceState>('idle')

// UI display atoms (set by route hook)
export const exportStatusAtom = atom<ExportStatus>({
	komboStatus: 'disabled',
	komboToolId: '',
	komboIntegrationType: '',
})

export const availableExportTargetsAtom = atom<AvailableExportTarget[]>([])
export const selectedExportTargetAtom = atom<AvailableExportTarget | null>(null)
export const isLoadingExportAtom = atom<boolean>(false)
export const isLoadingAvailableTargetsAtom = atom<boolean>(false)

// Pagination cursor (indicates more results available)
export const exportTargetNextCursorAtom = atom<string | null>(null)

// Load more callback (set by route hook)
export const loadMoreExportTargetsAtom = atom<(() => void) | null>(null)
export const isLoadingMoreTargetsAtom = atom<boolean>(false)

// True until the current campaign's mapping has been fetched and resolved against available targets
export const isResolvingExportTargetAtom = atom<boolean>(true)

// Search query atom (UI-only, not persisted)
export const exportTargetSearchQueryAtom = atom<string>('')
